import Typography from '@mui/material/Typography';
import AuthLayout from './AuthLayout';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useState } from 'react';
import Button from '@mui/material/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
const ResetPasswordEmail = () => {
   const [showPassword, setShowPassword] = useState(false);
   const [confirmPassword, setConfirmPassword] = useState('');
   const [password, setPassword] = useState('');
   const [passwordError, setPasswordError] = useState('');
   const [confirmPasswordError, setConfirmPasswordError] = useState('');
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState('');
   const navigate = useNavigate();
   const [searchParams] = useSearchParams();
   const token = searchParams.get('token');
   const [isLoading, setIsLoading] = useState(false);
   const [success, setSuccess] = useState('');

   const handleSubmit = async () => {
      try {
         if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
         }

         setIsLoading(true);
         const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/reset-password`, {
            method: 'POST',
            body: JSON.stringify({ newPassword: password }),
            headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${token}`,
            },
         });

         const data = await response.json();

         if (data.status == 400) {
            setError(data.message);
            return;
         }

         setSuccess('Password reset successfully');

         setTimeout(() => {
            navigate('/login');
         }, 3000);
      } catch (error: any) {
         setError(error.message);
      } finally {
         setTimeout(() => {
            setError('');
            setSuccess('');
         }, 5000);
         setIsLoading(false);
      }
   };

   return (
      <AuthLayout>
         {error && (
            <Alert sx={{ mb: 2 }} severity='error'>
               {error}
            </Alert>
         )}
         {success && (
            <Alert sx={{ mb: 2 }} severity='success'>
               {success}
            </Alert>
         )}
         <Typography variant='h4' color='primary'>
            Reset Password
         </Typography>
         <Typography variant='body1' sx={{ mb: 4 }} color='text.secondary'>
            Please enter the email address you used when you joined and we’ll send you instructions
            to reset your password.
         </Typography>

         <Grid container spacing={2}>
            <Grid item xs={12} sx={{ mb: 2 }}>
               <TextField
                  fullWidth
                  label='Password'
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  // error={!!passwordError}
                  // helperText={passwordError}
                  InputProps={{
                     startAdornment: (
                        <InputAdornment position='start'>
                           <LockIcon color='primary' />
                        </InputAdornment>
                     ),
                     endAdornment: (
                        <InputAdornment position='end'>
                           <IconButton onClick={() => setShowPassword(!showPassword)} edge='end'>
                              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                           </IconButton>
                        </InputAdornment>
                     ),
                  }}
                  required
               />
            </Grid>
            <Grid item xs={12}>
               <TextField
                  fullWidth
                  label='Confirm Password'
                  type={showPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  // error={!!confirmPasswordError}
                  // helperText={confirmPasswordError}
                  InputProps={{
                     startAdornment: (
                        <InputAdornment position='start'>
                           <LockIcon color='primary' />
                        </InputAdornment>
                     ),
                  }}
                  required
               />
            </Grid>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
               <Button
                  fullWidth
                  variant='contained'
                  color='primary'
                  disabled={isLoading}
                  onClick={handleSubmit}
               >
                  {isLoading ? <CircularProgress size={20} /> : ' Reset Password'}
               </Button>
            </Grid>
         </Grid>
      </AuthLayout>
   );
};

export default ResetPasswordEmail;
